<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="公司名称"
        v-model.trim="companyName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        size="small"
        v-model="invoiceType"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in invoice_type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        size="small"
        class="mr10"
        v-model="startTime"
        type="date"
        @change="search"
        :editable="false"
        format="YYYY-MM-DD"
        placeholder="开始时间"
        :disabledDate="startDisabledDate"
      >
      </el-date-picker>
      <el-date-picker
        size="small"
        v-model="endTime"
        type="date"
        @change="search"
        :editable="false"
        format="YYYY-MM-DD"
        placeholder="结束时间"
        :disabledDate="endDisabledDate"
      >
      </el-date-picker>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column
        prop="name"
        width="220px"
        label="开票抬头"
        header-align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="发票类型"
        prop="invoice_type"
        :formatter="formatType"
      >
      </el-table-column>
      <el-table-column
        align="center"
        width="180px"
        label="社会统一信用代码"
        prop="unified_social_credit_code"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="contact_name"
        label="联系人"
      ></el-table-column>
      <el-table-column
        prop="contact_phone"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column min-width="170" align="center" label="申请时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column min-width="100px" align="center" label="开票金额">
        <template #default="scope">{{ scope.row.totalPrice }}元 </template>
      </el-table-column>
      <el-table-column min-width="120px" align="center" label="开票信息">
        <template #default="scope">
          <el-button type="text" @click="lookInfo(scope.row)"
            >开票信息</el-button
          >
        </template>
      </el-table-column>
      <el-table-column min-width="120px" align="center" label="开票时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.invoice_date, "yyyy-MM-dd") }}
        </template>
      </el-table-column>

      <el-table-column label="发票详情" width="140" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            @click="confirmInvoicing(scope.row)"
            >发票详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 开票信息 -->
    <el-dialog v-model="invoicing_dialog" width="900px" destroy-on-close>
      <div class="invoicing_dialog-body">
        <h2 v-if="itemData.unified_social_credit_code">开票信息</h2>
        <table v-if="itemData.unified_social_credit_code">
          <tbody>
            <tr>
              <td>发表抬头</td>
              <td>{{ itemData.name }}</td>
            </tr>
            <tr>
              <td>统一社会信用代码</td>
              <td>{{ itemData.unified_social_credit_code }}</td>
            </tr>
            <tr>
              <td>发票类型</td>
              <td>{{ formatType(itemData) }}</td>
            </tr>
            <tr>
              <td>注册地址</td>
              <td>{{ itemData.address }}</td>
            </tr>
            <tr>
              <td>注册电话</td>
              <td>{{ itemData.phone }}</td>
            </tr>
            <tr>
              <td>开户银行</td>
              <td>{{ itemData.bank_name }}</td>
            </tr>
            <tr>
              <td>银行账户</td>
              <td>{{ itemData.bank_account }}</td>
            </tr>
          </tbody>
        </table>
        <h2>接收地址</h2>
        <table>
          <tbody>
            <tr>
              <td>收件人</td>
              <td>{{ itemData.receiver_name }}</td>
            </tr>
            <tr>
              <td>地址</td>
              <td>{{ itemData.receiver_address }}</td>
            </tr>
            <tr>
              <td>联系方式</td>
              <td>{{ itemData.receiver_phone }}</td>
            </tr>
          </tbody>
        </table>
        <h2>开票涉及订单信息</h2>
        <table :key="index" v-for="(item, index) in itemData.orderList">
          <tbody>
            <tr>
              <td>订单编号</td>
              <td>{{ item.order_code }}</td>
            </tr>
            <tr>
              <td>商品信息</td>
              <td>{{ item.order_name }}</td>
            </tr>
            <tr>
              <td>订单金额</td>
              <td>￥{{ item.order_price }}</td>
            </tr>
            <tr>
              <td>支付方式</td>
              <td>{{ payType(item.pay_type) }}</td>
            </tr>
            <tr>
              <td>支付时间</td>
              <td>
                {{ $utils.formatDate(item.order_time, "yyyy-MM-dd hh:mm:ss") }}
              </td>
            </tr>
          </tbody>
        </table>
        <li class="totalPrice">合计：￥{{ itemData.totalPrice }}</li>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="invoicing_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 开票详情 -->
    <el-dialog
      v-model="dialog"
      width="600px"
      title="纸质发票"
      destroy-on-close
      @close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-body">
        <el-form
          size="mini"
          :model="form"
          :rules="rules"
          ref="form"
          inline
          label-width="100px"
          label-position="right"
        >
          <h2>输入发票信息</h2>
          <div>
            <el-form-item label="发票代码：" prop="invoiceCode">
              <el-input
                v-if="modify"
                v-model="form.invoiceCode"
                placeholder="请输入发票代码"
              ></el-input>
              <span v-else>{{ form.invoiceCode }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="发票号码：" prop="invoiceNumber">
              <el-input
                v-if="modify"
                v-model="form.invoiceNumber"
                placeholder="请输入发票代码"
              ></el-input>
              <span v-else>{{ form.invoiceNumber }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="开票日期：" prop="invoiceDate">
              <el-date-picker
                v-if="modify"
                v-model="form.invoiceDate"
                type="date"
                :editable="false"
                format="YYYY-MM-DD"
                placeholder="开始时间"
              >
              </el-date-picker>
              <span v-else>{{
                $utils.formatDate(form.invoiceDate, "yyyy-MM-dd")
              }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="开票金额：" prop="invoiceAmount">
              <el-input
                v-if="modify"
                v-model="form.invoiceAmount"
                placeholder="请输入开票金额"
              ></el-input>
              <span v-else>{{ form.invoiceAmount }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="备注：">
              <el-input
                v-if="modify"
                v-model="form.invoiceRemark"
                type="textarea"
                resize="none"
                rows="8"
                placeholder="请输入内容"
                maxlength="200"
                show-word-limit
              >
              </el-input>
              <p v-else>{{ form.invoiceRemark }}</p>
            </el-form-item>
          </div>
          <h2>输入快递信息</h2>
          <div>
            <el-form-item label="快递名称：" prop="expressName">
              <el-select v-if="modify" v-model="form.expressName">
                <el-option
                  v-for="item in exportsData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span v-else>{{ form.expressName }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="快递单号：" prop="expressNumber">
              <el-input
                v-if="modify"
                v-model="form.expressNumber"
                placeholder="请输入开票金额"
              ></el-input>
              <span v-else>{{ form.expressNumber }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="发出日期：" prop="expressDate">
              <el-date-picker
                v-model="form.expressDate"
                type="date"
                v-if="modify"
                :editable="false"
                format="YYYY-MM-DD"
                placeholder="开始时间"
              >
              </el-date-picker>
              <span v-else>{{
                $utils.formatDate(form.expressDate, "yyyy-MM-dd")
              }}</span>
            </el-form-item>
          </div>
        </el-form>
        <li class="modify-button">
          <el-button
            type="primary"
            size="mini"
            v-if="!modify"
            @click="modify = true"
            >修改</el-button
          >
          <el-button type="primary" size="mini" v-if="modify" @click="save"
            >保存</el-button
          >
          <el-button type="danger" size="mini"  v-if="modify" @click="modify = false"
            >取消</el-button
          >
        </li>
        <h2>修改记录</h2>
        <el-table
          :data="listData.records"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
        >
          <el-table-column align="center" label="修改时间">
            <template #default="scope">
              {{
                $utils.formatDate(scope.row.update_time, "yyyy-MM-dd hh:mm:ss")
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="修改者" prop="realname">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="listData.current"
            :page-size="10"
            :total="listData.total"
            @current-change="getModifyRecord"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var dayjs = require("dayjs");
export default {
  data() {
    return {
      data: {},
      companyName: "",
      invoiceType: "",
      invoice_type_options: [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "普票",
        },
        {
          value: 2,
          label: "专票",
        },
      ],
      exportsData: [
        { label: "中国邮政集团公司", value: "中国邮政集团公司" },
        { label: "中铁快运", value: "中铁快运" },
        { label: "申通快递公司", value: "申通快递公司" },
        { label: "圆通快递公司", value: "圆通快递公司" },
        { label: "中通快递公司", value: "中通快递公司" },
        { label: "顺丰快递公司", value: "顺丰快递公司" },
        { label: "德邦物流", value: "德邦物流" },
        { label: "韵达快递", value: "韵达快递" },
        { label: "宅急送", value: "宅急送" },
        { label: "京东快递", value: "京东快递" },
      ],
      startTime: "",
      endTime: "",
      invoicing_dialog: false,
      dialog: false,
      itemData: {},
      form: {
        invoiceCode: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceAmount: "",
        expressName: "",
        expressNumber: "",
        expressDate: "",
        invoiceRemark: "",
      },
      rules: {
        invoiceCode: [
          { required: true, message: "请输入发票代码", trigger: "blur" },
          { min: 1, max: 30, message: "长度不能超过30位", trigger: "blur" },
          {
            required: true,
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能输入数字和字母",
            trigger: "blur",
          },
        ],
        invoiceNumber: [
          { required: true, message: "请输入发票号码", trigger: "blur" },
          { min: 1, max: 30, message: "长度不能超过30位", trigger: "blur" },
          {
            required: true,
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能输入数字和字母",
            trigger: "blur",
          },
        ],
        invoiceDate: [
          {
            required: true,
            message: "请选择开票日期",
            trigger: ["change", "blur"],
          },
        ],
        invoiceAmount: [
          { required: true, message: "请输入开票金额", trigger: "blur" },
          {
            required: true,
            pattern: /^([1-9]\d{0,9}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
            message: "必须是数字小数点前最多十位小数点后最多两位",
            trigger: "blur",
          },
        ],
        expressName: [
          {
            required: true,
            message: "请选择快递名称",
            trigger: ["change", "blur"],
          },
        ],
        expressNumber: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
          { min: 1, max: 30, message: "长度不能超过30位", trigger: "blur" },
          {
            required: true,
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能输入数字和字母",
            trigger: "blur",
          },
        ],
        expressDate: [
          {
            required: true,
            message: "请选择发出时间",
            trigger: ["change", "blur"],
          },
        ],
      },
      loading: false,
      modify: false,
      listData: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    startDisabledDate(time) {
      if (!this.endTime) return false;
      time = new Date(time);
      var date = new Date(this.endTime);
      return time.getTime() > date.getTime();
    },
    endDisabledDate(time) {
      if (!this.startTime) return false;
      time = new Date(time);
      var date = new Date(this.startTime);
      return time.getTime() < date.getTime();
    },
    search() {
      this.getData();
    },
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          invoiceType: this.invoiceType,
          startTime: this.startTime
            ? dayjs(this.startTime).format("YYYY-MM-DD")
            : "",
          endTime: this.endTime ? dayjs(this.endTime).format("YYYY-MM-DD") : "",
          name: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.invoice.completed.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    async getModifyRecord(page = 1) {
      try {
        const params = {
          invoicingId: this.itemData.id,
          currentPage: page,
          pageSize: 10,
        };
        this.$loading.start();
        const res = await this.$api.invoice.completed.getModifyRecord(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.listData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    formatType(row) {
      switch (row.invoice_type) {
        case 1:
          return "普票";
        case 2:
          return "专票";
      }
    },
    payType(type) {
      switch (type) {
        case -1:
          return "公司转账";
        case 0:
          return "免费";
        case 1:
          return "微信支付";
        case 2:
          return "支付宝支付";
      }
    },
    lookInfo(data) {
      this.itemData = { ...data };
      this.itemData.orderList = [...JSON.parse(this.itemData.orderList)];
      this.invoicing_dialog = true;
    },
    async confirmInvoicing(data) {
      this.itemData = data;
      this.form = {
        invoiceCode: data.invoice_code,
        invoiceNumber: data.invoice_number,
        invoiceDate: data.invoice_date,
        invoiceAmount: data.invoice_amount,
        expressName: data.express_name,
        expressNumber: data.express_number,
        expressDate: data.express_delivery_time,
        invoiceRemark: data.invoice_remark,
      };
      await this.getModifyRecord();
      this.dialog = true;
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitReject();
        } else {
          return false;
        }
      });
    },
    // 操作数据
    async submitReject() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            invoicingId: this.itemData.id,
            ...this.form,
          };
          params.invoiceDate = dayjs(params.invoiceDate).format("YYYY-MM-DD");
          params.expressDate = dayjs(params.expressDate).format("YYYY-MM-DD");
          const res = await this.$api.invoice.completed.setData(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.dialog = false;
            this.getData(this.data.current);
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    close() {
      this.form = {
        invoiceCode: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceAmount: "",
        expressName: "",
        expressNumber: "",
        expressDate: "",
      };
      this.modify = false;
    },
  },
  watch: {
    status: {
      handler(val, ovl) {
        this.getData();
      },
    },
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.end {
  color: $--color-danger;
}

.report {
  cursor: pointer;
}

.preview-dialog {
  img {
    width: 100%;
  }
}

.invoicing_dialog-body {
  h2 {
    font-weight: 500;
    font-size: 1rem;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    margin-bottom: 10px;
    tr {
      td {
        padding: 10px;
        font-size: 0.875rem;
        border: 1px solid $--border-color-base;

        &:first-child {
          width: 120px;
          text-align: right;
          background-color: #f6f6f6;
        }
      }
    }
  }

  .totalPrice {
    font-size: 1.2rem;
  }
}

.dialog-body {
  h2 {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 12px;
    color: #333333;
  }

  .el-input {
    width: 220px;
  }

  .el-textarea {
    width: 400px;
  }

  p {
    width: 400px;
  }

  .modify-button {
    text-align: center;
  }
}
</style>